import React from 'react';
import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { Spinner } from 'js/social/shared/CreateSocialItem/Spinner';
import { AiButtonType } from 'js/social/shared/types';
import { TypeWriter } from './TypeWriter';

const SummaryContainer = styled.div<{ type: AiButtonType }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: var(--text-primary);

  &.type-finding {
    background: #edf9fb;
    padding: var(--spacing-sm-24);
  }

  @include for-tablet-sm-up {
    &.type-finding {
      padding: var(--spacing-sm-24) 32px;
    }
  }

  &.type-figure {
    background: var(--brand-colors-blue-100);
    padding: var(--spacing-sm-24) var(--spacing-xs-16);
  }
`;

const SummaryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SummaryHeaderText = styled(Body)`
  font-weight: 600;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: var(--spacing-xs-8) 0;
`;

type AiSummaryProps = {
  type: AiButtonType;
  loading: boolean;
  summary?: string;
};

export const AiSummary: React.FC<AiSummaryProps> = ({
  type,
  loading,
  summary,
}) => {
  if (!loading && !summary) return null;

  return (
    <SummaryContainer type={type}>
      <SummaryHeader>
        <SummaryHeaderText size="md">Explain this {type}</SummaryHeaderText>
        <Body size="sm">Generated by AI</Body>
      </SummaryHeader>
      <Body size="sm">
        {loading || !summary ? (
          <LoadingContainer>
            <Spinner />
          </LoadingContainer>
        ) : (
          <TypeWriter presetHeight text={summary} speed={30} />
        )}
      </Body>
    </SummaryContainer>
  );
};
